export const redColor = '#F40009';
export const orangeColor = '#E98300';
export const blackColor ='#1E1E1E'
export const whiteColor = '#FFFFFF';
export const lightRedColor = '#f4000836';
export const twoGroupColor = [redColor, blackColor];
export const orangeBlackGroupColor = [orangeColor, '#474747'];
export const threeGroupColor = [redColor, blackColor, orangeColor];
export const redColorWithOpacity=[redColor, '#f400089c', lightRedColor];
export const blackColorWithOpacity=[blackColor, '#1e1e1ea4', '#1e1e1e60']